import React from 'react'
import PropTypes from 'prop-types'
import { Button } from 'ui-components/Button'
import { Spinner } from 'ui-components/Spinner'
import { SpinnerContainer } from './styles'

export default function RequestButton(props) {
  const {
    disabled,
    onClick,
    loading,
    text,
  } = props

  const renderSpinner = () => (
    <SpinnerContainer>
      <Spinner color="inherit" size="14px" />
    </SpinnerContainer>
  )

  return (
    <Button
      color="primary"
      disabled={disabled || loading}
      onClick={onClick}
    >
      { loading ? renderSpinner() : null }
      { text }
    </Button>
  )
}

RequestButton.propTypes = {
  disabled: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  text: PropTypes.string,
}

RequestButton.defaultProps = {
  disabled: false,
  loading: false,
  text: 'OK',
}
